/* globals appendQueryParam */
(function () {
	'use strict';

	angular.module('app.leanProjects')
		.service('viewMetricDataService', viewMetricDataService);

	viewMetricDataService.$inject = ['$http'];

	function viewMetricDataService($http) {
		var urlPrefix = '/api/2/factndx/' + globalConfig.factory.id + '/';
		return {
			updateMetricEntry: updateMetricEntry
		};

		function updateMetricEntry(metricEntry, date) {
			var url = urlPrefix + 'MetricEntries?';
			var dateString = date.toISOString().split('T')[0];
			url = appendQueryParam(url, 'date', dateString);
			var relevantData = {
				enabled: true,
				factoryNdx: metricEntry.leanDirFactoryNdx,
				metricNdx: metricEntry.metricNdx,
				valueStreamNdx: metricEntry.valueStreamNdx,
				value: metricEntry.value,
				valueA: metricEntry.valueA,
				valueB: metricEntry.valueB,
				dateModified: metricEntry.dateModified
			};
			return $http.put(url, [relevantData])
				.then(updateMetricEntryComplete)
				.catch(updateMetricEntryFailed);

			function updateMetricEntryComplete(response) {
				return response.data;
			}

			function updateMetricEntryFailed(error) {
				return error;
			}
		}
	}
})();
